import { TextField, Grid, FormControlLabel, Checkbox } from '@material-ui/core'
import { get } from 'lodash'
import React, { useCallback } from 'react'
import { TextMaskCC, TextMaskCVV, TextMaskExpiration } from './InputMasks'

import { pushSnowplow, toOrderProcessSchema } from '../../util/snowplow'

export const CreditCardDetail = ({
  creditCards,
  errors,
  handleBlur,
  handleChange,
  touched,
  values,
}) => {
  const getError = useCallback(name => get(touched, name) && get(errors, name), [errors, touched])

  return (
    <Grid container spacing={3} className={creditCards && creditCards.length > 0 && 'segment-push'}>
      <Grid item xs={12} md={6}>
        <TextField
          size="small"
          variant="outlined"
          color="secondary"
          fullWidth
          label="Credit Card Number"
          autoComplete="cc-number"
          id="cc.number"
          error={!!getError('cc.number')}
          helperText={getError('cc.number')}
          name="cc.number"
          onBlur={event => {
            handleBlur(event)
            pushSnowplow(
              toOrderProcessSchema(
                'daily',
                'checkout_credit_card_number',
                null,
                getError('cc.number'),
              ),
            )
          }}
          onChange={handleChange}
          type="text"
          value={values.cc.number}
          InputProps={{
            inputComponent: TextMaskCC,
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          size="small"
          variant="outlined"
          color="secondary"
          fullWidth
          label="CVV"
          autoComplete="cc-csc"
          id="cc.cvv"
          error={!!getError('cc.cvv')}
          helperText={getError('cc.cvv')}
          name="cc.cvv"
          onBlur={event => {
            handleBlur(event)
            pushSnowplow(
              toOrderProcessSchema('daily', 'checkout_credit_card_cvv', null, getError('cc.cvv')),
            )
          }}
          InputProps={{
            inputComponent: TextMaskCVV,
          }}
          onChange={handleChange}
          value={values.cc.cvv}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          size="small"
          variant="outlined"
          color="secondary"
          fullWidth
          label="Expiration"
          autoComplete="cc-expiration"
          id="cc.exp"
          error={!!getError('cc.exp')}
          helperText={getError('cc.exp')}
          name="cc.exp"
          onBlur={event => {
            handleBlur(event)
            pushSnowplow(
              toOrderProcessSchema('daily', 'checkout_credit_card_exp', null, getError('cc.exp')),
            )
          }}
          InputProps={{
            inputComponent: TextMaskExpiration,
          }}
          onChange={handleChange}
          value={values.cc.exp}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          size="small"
          variant="outlined"
          color="secondary"
          fullWidth
          label="First Name"
          autoComplete="cc-given-name"
          id="cc.firstName"
          error={!!getError('cc.firstName')}
          helperText={getError('cc.firstName')}
          name="cc.firstName"
          onBlur={event => {
            handleBlur(event)
            pushSnowplow(
              toOrderProcessSchema(
                'daily',
                'checkout_credit_card_first_name',
                null,
                getError('cc.firstName'),
              ),
            )
          }}
          onChange={handleChange}
          value={values.cc.firstName}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          size="small"
          variant="outlined"
          color="secondary"
          fullWidth
          label="Last Name"
          autoComplete="cc-last-name"
          id="cc.lastName"
          error={!!getError('cc.lastName')}
          helperText={getError('cc.lastName')}
          name="cc.lastName"
          onBlur={event => {
            handleBlur(event)
            pushSnowplow(
              toOrderProcessSchema(
                'daily',
                'checkout_credit_card_last_name',
                null,
                getError('cc.lastName'),
              ),
            )
          }}
          onChange={handleChange}
          value={values.cc.lastName}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          size="small"
          variant="outlined"
          color="secondary"
          fullWidth
          label="Postal Code"
          autoComplete="postal-code"
          id="cc.zip"
          error={!!getError('cc.zip')}
          helperText={getError('cc.zip')}
          name="cc.zip"
          onBlur={event => {
            handleBlur(event)
            pushSnowplow(
              toOrderProcessSchema(
                'daily',
                'checkout_credit_card_zip_code',
                null,
                getError('cc.zip'),
              ),
            )
          }}
          onChange={handleChange}
          value={values.cc.zip}
        />
      </Grid>
      <Grid item xs={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.saveCard}
              onChange={e => {
                handleChange(e)
              }}
              name="saveCard"
              color="primary"
              onBlur={event => {
                pushSnowplow(
                  toOrderProcessSchema('daily', 'checkout_credit_card_save', event.target.checked),
                )
                handleBlur(event)
              }}
            />
          }
          label="Save card for future use"
        />
      </Grid>
    </Grid>
  )
}
export default CreditCardDetail
